import { render, staticRenderFns } from "./WileyTreatmentPlanChartReview.vue?vue&type=template&id=a601c800&"
import script from "./WileyTreatmentPlanChartReview.vue?vue&type=script&lang=js&"
export * from "./WileyTreatmentPlanChartReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports